<template>
  <div id="WeightRow">
    <div class="row-box">
      <span class="placeholder" v-for="index in leftPlaceHoderCount" :key="'a'+index"></span>
      <span class="type-label">{{ weightData.typeLabel }}</span>
      <span class="placeholder" v-for="index in rightPlaceHoderCount" :key="'b'+index"></span>
      <span class="weight">{{ weightData.totalWeight }}</span>
      <div class="date-weight" v-for="(item,index) in weightData.dateList" :key="'c'+index">
        <span class="date-weight">{{ item.weight }}</span>
        <span class="date-weight">{{ weightData.type == "order" && item.rawData ? item.rawData.toFixed(2) : item.rawData}}</span>
        <span class="date-weight">{{ item.weightRate ? item.weightRate.toFixed(2) : "0.00" }}</span>
      </div>
    </div>
    <div class="row-detail" v-for="(wData,i) in weightData.detailList" :key="'d'+i">
      <!-- <div class="row-box" v-if="weightData.detailList <= 0">
        <span class="Placeholder" v-for="index in detailLeftPlaceHoderCount" :key="'e'+index"></span>
        <span class="type-label">{{ wData.typeLabel }}</span>
        <span class="placeholder" v-for="index in detailRightPlaceHoderCount" :key="'f'+index"></span>
        <span class="weight">{{ wData.totalWeight }}</span>
        <div class="date-weight" v-for="(item,index) in wData.dateList" :key="'g'+index">
          <span class="date-weight">{{ item.weight }}</span>
          <span class="date-weight">{{ item.type == "order" && item.rawData? item.rawData.toFixed(2) : item.rawData }}</span>
          <span class="date-weight">{{ item.weightRate ? item.weightRate.toFixed(2) : "0.00" }}</span>
        </div>
      </div> -->
      <div class="row-detail-list">
        <slot :name="'detail'+i"></slot>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    leftPlaceHoderCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    rightPlaceHoderCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    weightData: {
      type: Object,
      default() {
        return { totalWeight: 0, detailList: [] };
      },
    }
  },
  data() {
    return {
      detailLeftPlaceHoderCount: this.leftPlaceHoderCount + 1,
      detailRightPlaceHoderCount: this.rightPlaceHoderCount + 1,

    };
  },
  mounted() {

  },
  methods: {
    getRandom() {
      return Math.random() + "";
    }
  }
};
  </script>
  
<style lang="scss">
#WeightRow {
  .row-box,
  .row-detail {
    span,
    .date-weight {
      display: inline-block;
      font-size: 12px;
      width: 43px;
      text-align: right;
      vertical-align: top;
    }
    .type-label,
    .weight {
      width: 60px;
    }
    .placeholder {
      width: 60px;
    }
  }
  .row-box:hover {
    background-color: antiquewhite;
  }
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
  }

  .el-table tr:hover {
    background-color: #f5f5f5;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table tr.highlight-row td {
    background-color: yellow;
  }

  .el-table__header th.highlight-column {
    background-color: yellow;
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
  